import { render, staticRenderFns } from "./conversion.vue?vue&type=template&id=5af31ae4&scoped=true"
import script from "./conversion.vue?vue&type=script&lang=js"
export * from "./conversion.vue?vue&type=script&lang=js"
import style0 from "./conversion.vue?vue&type=style&index=0&id=5af31ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af31ae4",
  null
  
)

export default component.exports